import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import EditIcon from "components/Icons/EditIcon";
import ViewIcon from "components/Icons/ViewIcon";
import { IUser } from "models/user";

interface IProps {
  user: IUser;
  onEdit: () => void;
}

export default function PassengerAction({ user, onEdit }: IProps) {
  return (
    <div className="flex items-center gap-x-3">
      <Link
        to={RouteName.PASSENGER_DETAIL.replace(":id", user.id)}
        className="rounded-full hover:text-black"
      >
        <ViewIcon />
      </Link>
      <button
        onClick={onEdit}
        className="rounded-full hover:text-black"
      >
        <EditIcon />
      </button>
    </div>
  );
}
